import CardParques from './CardParques';
export default CardParques;